var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticStyle:{"z-index":"1000"},attrs:{"items":_vm.languages,"label":"Language"},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }